import { ReactElement } from 'react';

import { Skeleton } from '@beeline/design-system-react/extracted-styles';

import { SkeletonBody } from './SkeletonBody';
import styles from './styles.module.scss';

export function WidgetSkeleton(): ReactElement {
  return (
    <li className={styles.widget}>
      <div className={styles.head}>
        <div className={styles.nameLink}>
          <Skeleton variant='circle' radius={12} />
          <Skeleton variant='line' width={120} height={22} />
        </div>
        <Skeleton variant='circle' width={22} height={22} />
      </div>
      <SkeletonBody />
    </li>
  );
}
